import { AccountAccessPage } from './pages/AccountAccessPage';
import { AddTeamMembersPage } from './pages/AddTeamMembersPage';
import { CircuitLapSetupPage } from './pages/CircuitLapSetupPage';
import { ChatGptPluginPage } from './pages/ChatGptPluginPage';
import { CompareLapsPage } from './pages/CompareLapsPage';
import { LandingPage } from './pages/LandingPage';
import { PaddiqLinkGuidePage } from './pages/PaddiqLinkGuidePage';
import { PaddiqLinkSessionsPage } from './pages/PaddiqLinkSessionsPage';
import { PaddiqLinkFileCopiesPage } from './pages/PaddiqLinkFileCopiesPage';
import { PaddiqLinkRaceStudioPage } from './pages/PaddiqLinkRaceStudioPage';
import { PaddiqLinkTroubleshootingPage } from './pages/PaddiqLinkTroubleshootingPage';
import { PaddiqLinkPage } from './pages/PaddiqLinkPage';
import { GettingStartedPage } from './pages/GettingStartedPage';
import { IdealLineGuidePage } from './pages/IdealLineGuidePage';
import { GarageVehicleSetupPage } from './pages/GarageVehicleSetupPage';
import { ImportMyChronIPhonePage } from './pages/ImportMyChronIPhonePage';
import { IPhoneSessionAnalysisPage } from './pages/IPhoneSessionAnalysisPage';
import { IPhoneSessionTroubleshootingPage } from './pages/IPhoneSessionTroubleshootingPage';
import { LeaderboardGuidePage } from './pages/LeaderboardGuidePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ProductUpdatesPage } from './pages/ProductUpdatesPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { SessionBillingPage } from './pages/SessionBillingPage';
import { SupportPage } from './pages/SupportPage';
import { TermsPage } from './pages/TermsPage';
import { TroubleshootSessionsPage } from './pages/TroubleshootSessionsPage';
import { UploadMyChronPage } from './pages/UploadMyChronPage';

function currentPage() {
  const path = window.location.pathname.replace(/\/+$/, '');
  if (path === '/resources/paddiq-link') return 'paddiq-link-guide';
  if (path === '/resources/paddiq-link-sessions') return 'paddiq-link-sessions';
  if (path === '/resources/paddiq-link-file-copies') return 'paddiq-link-file-copies';
  if (path === '/resources/paddiq-link-race-studio') return 'paddiq-link-race-studio';
  if (path === '/resources/paddiq-link-troubleshooting') return 'paddiq-link-troubleshooting';
  if (path === '/paddiq-link') return 'paddiq-link';
  if (path === '/chatgpt') return 'chatgpt';
  if (path === '/privacy') return 'privacy';
  if (path === '/terms') return 'terms';
  if (path === '/resources') return 'resources';
  if (path === '/resources/account-access') return 'account-access';
  if (path === '/resources/getting-started') return 'getting-started';
  if (path === '/resources/add-vehicle-setup') return 'add-vehicle-setup';
  if (path === '/resources/add-team-members') return 'add-team-members';
  if (path === '/resources/set-up-circuit-laps') return 'set-up-circuit-laps';
  if (path === '/resources/troubleshoot-session-uploads') return 'troubleshoot-session-uploads';
  if (path === '/resources/upload-mychron-session') return 'upload-mychron-session';
  if (path === '/resources/import-mychron-iphone') return 'import-mychron-iphone';
  if (path === '/resources/analyze-sessions-iphone') return 'analyze-sessions-iphone';
  if (path === '/resources/troubleshoot-sessions-iphone') return 'troubleshoot-sessions-iphone';
  if (path === '/resources/compare-laps-and-traces') return 'compare-laps-and-traces';
  if (path === '/resources/fastest-recorded-lap') return 'fastest-recorded-lap';
  if (path === '/resources/use-leaderboard') return 'use-leaderboard';
  if (path === '/resources/session-billing') return 'session-billing';
  if (path === '/resources/product-updates') return 'product-updates';
  return path === '/support' ? 'support' : 'landing';
}

export function App() {
  const page = currentPage();
  if (page === 'paddiq-link-guide') return <PaddiqLinkGuidePage />;
  if (page === 'paddiq-link-sessions') return <PaddiqLinkSessionsPage />;
  if (page === 'paddiq-link-file-copies') return <PaddiqLinkFileCopiesPage />;
  if (page === 'paddiq-link-race-studio') return <PaddiqLinkRaceStudioPage />;
  if (page === 'paddiq-link-troubleshooting') return <PaddiqLinkTroubleshootingPage />;
  if (page === 'paddiq-link') return <PaddiqLinkPage />;
  if (page === 'chatgpt') return <ChatGptPluginPage />;
  if (page === 'privacy') {
    return <PrivacyPage />;
  }
  if (page === 'terms') {
    return <TermsPage />;
  }
  if (page === 'support') {
    return <SupportPage />;
  }
  if (page === 'resources') {
    return <ResourcesPage />;
  }
  if (page === 'account-access') {
    return <AccountAccessPage />;
  }
  if (page === 'getting-started') {
    return <GettingStartedPage />;
  }
  if (page === 'add-vehicle-setup') {
    return <GarageVehicleSetupPage />;
  }
  if (page === 'add-team-members') {
    return <AddTeamMembersPage />;
  }
  if (page === 'set-up-circuit-laps') {
    return <CircuitLapSetupPage />;
  }
  if (page === 'upload-mychron-session') {
    return <UploadMyChronPage />;
  }
  if (page === 'import-mychron-iphone') {
    return <ImportMyChronIPhonePage />;
  }
  if (page === 'analyze-sessions-iphone') {
    return <IPhoneSessionAnalysisPage />;
  }
  if (page === 'troubleshoot-sessions-iphone') {
    return <IPhoneSessionTroubleshootingPage />;
  }
  if (page === 'troubleshoot-session-uploads') {
    return <TroubleshootSessionsPage />;
  }
  if (page === 'compare-laps-and-traces') {
    return <CompareLapsPage />;
  }
  if (page === 'fastest-recorded-lap') {
    return <IdealLineGuidePage />;
  }
  if (page === 'use-leaderboard') {
    return <LeaderboardGuidePage />;
  }
  if (page === 'session-billing') {
    return <SessionBillingPage />;
  }
  if (page === 'product-updates') {
    return <ProductUpdatesPage />;
  }
  return <LandingPage />;
}
